import BIForm from "./form";
import CountryPhonePlugin from '../ui/country_phone_plugin.js'
import Route from '../route';

$(function () {
    if (Route === "account-information" || Route === "account-confirm-details") {
        // To be enabled when Sage write functions for this are ready
        /*
        let accountFormId = '#accountInformationForm';

        let AccountInfoForm = new BIForm({
            form_id: accountFormId,
        });
        AccountInfoForm.addSubmitListener((response) => {
            window.location.reload();
        });

        let countrySelect = new CountryPhonePlugin("#phoneNumberSmall");
        */
    }
});
